import styled from 'styled-components';

import * as Common from '../../Styles';
import * as MUIIcon from '@mui/icons-material';

const Theme = Common.Theme;

export const MenuIcon = styled(MUIIcon.Menu)``;

export const CalenderIcon = styled(MUIIcon.CalendarToday)`
	font-size: 18px;
	align-self: center;
`;

export const ScheduleIcon = styled(MUIIcon.Schedule)`
	font-size: 16px !important;
`;

export const ArrowDownIcon = styled(MUIIcon.KeyboardArrowDown)`
	margin-left: auto;
	color: ${Theme.green};
`;

export const DSODropdownIcon = styled(MUIIcon.KeyboardArrowDown)`
	position: relative;
	top: 5px;
	margin-left: auto;
	color: ${Theme.green};
`;

export const CalendarIcon = styled(MUIIcon.DateRange)`
	font-size: 16px !important;
`;

export const ProcessingIcon = styled(MUIIcon.Sync)`
	font-size: 16px !important;
	padding: 5px;
`;

export const AddIcon = styled(MUIIcon.PlaylistAddOutlined)`
	font-size: 16px !important;
	padding: 5px;
`;

export const GoToIcon = styled(MUIIcon.ExitToApp)`
	font-size: 16px !important;
	padding: 5px;
`;